import React, { useEffect, useState } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import './order.css';
import { Route, NavLink, useRouteMatch, Redirect, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import NewOpportunity from './Opportunity/NewOpportunity';
import AllOpportunity from './Opportunity/AllOpportunity';
import OutOfStockOpportunity from './Opportunity/OutOfStockOpportunity';
import api from "../seller-apis/api";
// approved Product opp added
import { approvedProducts, approvedProductsOpp, fetchOpportunityData } from '../seller-apis/apidataField';
import { Actions } from '../Actions/Actions';
import PriceOpportunity from './Opportunity/PriceOpportunity';
import ProductOpportunitiesTabs from './OrderComponents/ProductOpportunitiesTabs';

function Opportunities() {
  const history = useHistory();
  const dispatch = useDispatch();
  const stateData = useSelector(state => state);
  const { path, url } = useRouteMatch()
  const currentUrl = window.location.pathname;
  const [allOpportunityCount, setAllOpportunityCount] = useState(0);
  const [outOfStockOpportunityCount, setOutOfStockOpportunityCount] = useState(0);
  const [priceOpportunityCount, setPriceOpportunityCount] = useState(0);
  

  const pageName = path[path.length - 1];
  useEffect(() => {
    setOutOfStockOpportunityCount(stateData.ActionReducer.opportunityOutOfStockCount);

  }, [stateData.ActionReducer]);
  
  useEffect(() => {
    if (localStorage.getItem("vendorState") === "partialInactive") {
      history.replace("/home");
      return false;
    }
    var outOfStockOpp = {
      "pageNo": 1,
      "prStatus": {
        "$and": [
          {
            "prSts": { "$exists": true }
          },
          {
            "prSts": { "$ne": "V_PENDING" },
          }
        ]
      },
      "status": {
        "active": true
      },
      "orCondt": {
        "$or": [
          {
            "vActive": "INACTIVE",
          },
          {
            "combination.vActive": "INACTIVE"
          }
        ]
      }
    }

    // api.product.productsRetrieveall(approvedProducts(outOfStockOpp)).then(res => {
    //   setOutOfStockOpportunityCount(res.totalRecords);
    //   Actions.OpportunityOutOfStockCountAction(dispatch, res.totalRecords);
    // });
    //set approvedProductsOpp
    api.Opportunity.fetchOutOfStockOpportunity(approvedProductsOpp(outOfStockOpp)).then(res => {

      setOutOfStockOpportunityCount(res.totalRecords);
      Actions.OpportunityOutOfStockCountAction(dispatch, res.totalRecords);
    });

    var pricingOpp = {
      pageNo: 1,
      size: 1,
      filters: {
      }
    }
    api.Opportunity.fetchPriceOpportunity(fetchOpportunityData(pricingOpp)).then(res => {
      setPriceOpportunityCount(res.totalRecords);
    });

  }, [])

  return (
    <>

      <div className="container mb-4">
        {/* <div className='order-tabs'>
          <div className='tab-container'>
              <NavLink exact to={`${url}/new-opportunities`} className="order_nav"><button className='filter_options_btn me-2' >Product opportunities ({newOpportunityCount})</button></NavLink>
              <NavLink to={`${url}/all-opportunities`} className="order_nav"><button className='filter_options_btn me-2'>Availed opportunities  ({allOpportunityCount})</button></NavLink>
              <NavLink to={`${url}/outofstock-opportunities`} className="order_nav"><button className='filter_options_btn me-2'>Re-stock opportunities ({outOfStockOpportunityCount})</button></NavLink>
              <NavLink to={`${url}/pricing-opportunities`} className="order_nav"><button className='filter_options_btn me-2'>Pricing opportunities ({priceOpportunityCount})</button></NavLink>
          </div>
        </div> */}
        <div className="new-tabs">
          <div className="tab-container" style={{ position: "relative" }}>
            <NavLink
              to={`${url}/product-opportunities`}
              className="tabs"
            >
              Product opportunities

            </NavLink>
            <NavLink
              exact
              to={`${url}/outofstock-opportunities`}
              className="tabs"
            >
              Re-stock opportunities
              <div class="menu-count-border order-menu-count">
                {outOfStockOpportunityCount}
              </div>

            </NavLink>
            {priceOpportunityCount > 0 && <NavLink
              exact
              to={`${url}/pricing-opportunities`}
              className="tabs"
            >
              Pricing opportunities
              <div class="menu-count-border order-menu-count">
                {priceOpportunityCount}
              </div>

            </NavLink>}

          </div>
        </div>
      </div>
      <div>
        <Route exact path="/opportunities">
          <Redirect to={`${path}/product-opportunities`} />
        </Route>
        <Route path={`${path}/product-opportunities`} component={ProductOpportunitiesTabs} />
        <Route exact path={`${path}/outofstock-opportunities`} component={OutOfStockOpportunity} />
        {/*<Route exact path={`${path}/pricing-opportunities`} component={PriceOpportunity} />*/}
        <Route 
          exact 
          path={`${path}/pricing-opportunities`} 
          render={(props) => (
            <PriceOpportunity {...props} updateCount={setPriceOpportunityCount} />
          )}
        />
      </div>
    </>
  )
}


export default Opportunities;